"use client";
import { useEffect, useState } from "react";

interface Testimonial {
  quote: string;
  author: string;
  role: string;
}

interface TestimonialCarouselProps {
  testimonials: Testimonial[];
  customersTitle: string;
  autoRotateInterval?: number;
}

export function TestimonialCarousel({
  testimonials,
  customersTitle,
  autoRotateInterval = 5000,
}: TestimonialCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, autoRotateInterval);

    return () => clearInterval(interval);
  }, [testimonials.length, autoRotateInterval]);

  return (
    <div>
      <div className="text-xs uppercase tracking-wider text-white/60 mb-6">
        {customersTitle}
      </div>
      <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 min-h-[200px] border border-white/20 flex flex-col justify-between shadow-lg">
        <p className="text-white/90 text-sm mb-6 leading-relaxed">
          {testimonials[currentIndex].quote}
        </p>
        <div>
          <div className="text-white font-semibold">
            {testimonials[currentIndex].author}
          </div>
          <div className="text-white/60 text-xs">
            {testimonials[currentIndex].role}
          </div>
        </div>
      </div>

      <div className="flex gap-2 mt-6 justify-center">
        {testimonials.map((testimonial, index) => (
          <button
            key={testimonial.author}
            type="button"
            onClick={() => setCurrentIndex(index)}
            className={`h-1.5 rounded-full transition-all ${
              index === currentIndex ? "w-8 bg-white" : "w-1.5 bg-white/30"
            }`}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
